module.exports = __webpack_public_path__ + "img/夢莎逆時雙效洗顏皂Ⅱ.88711048.png";